import { BrowserRouter, Outlet, Route, Routes } from "react-router-dom";
import { Toaster } from "@/components/ui/sonner";
import { AuthProvider } from "@/context/AuthContext";
import { SmoothScroll } from "@/components/site/SmoothScroll";
import { Navbar } from "@/components/site/Navbar";
import { Footer } from "@/components/site/Footer";
import { WhatsAppFloat } from "@/components/site/WhatsApp";
import Landing from "@/pages/Landing";
import Events from "@/pages/Events";
import EventGallery from "@/pages/EventGallery";
import OrderPage from "@/pages/OrderPage";
import Photographers from "@/pages/Photographers";
import PhotographerProfile from "@/pages/PhotographerProfile";
import Login from "@/pages/Login";
import Panel from "@/pages/Panel";

const PublicLayout = () => (
  <SmoothScroll>
    <Navbar />
    <Outlet />
    <Footer />
    <WhatsAppFloat />
  </SmoothScroll>
);

export default function App() {
  return (
    <AuthProvider>
      <BrowserRouter>
        <Routes>
          <Route element={<PublicLayout />}>
            <Route path="/" element={<Landing />} />
            <Route path="/eventos" element={<Events />} />
            <Route path="/eventos/:slug" element={<EventGallery />} />
            <Route path="/pedido/:id" element={<OrderPage />} />
            <Route path="/fotografos" element={<Photographers />} />
            <Route path="/fotografos/:id" element={<PhotographerProfile />} />
          </Route>
          <Route path="/entrar" element={<Login />} />
          <Route path="/painel" element={<Panel />} />
          <Route path="*" element={<PublicLayout />}>
            <Route path="*" element={<main className="min-h-screen pt-40 text-center font-display text-3xl font-bold">Página não encontrada.</main>} />
          </Route>
        </Routes>
      </BrowserRouter>
      <Toaster position="top-center" theme="dark" richColors />
    </AuthProvider>
  );
}
